"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GetAccountAllOfRelayData {
    static getAttributeTypeMap() {
        return GetAccountAllOfRelayData.attributeTypeMap;
    }
}
GetAccountAllOfRelayData.discriminator = undefined;
GetAccountAllOfRelayData.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "relay",
        "baseName": "relay",
        "type": "string"
    },
    {
        "name": "port",
        "baseName": "port",
        "type": "number"
    }
];
exports.GetAccountAllOfRelayData = GetAccountAllOfRelayData;
//# sourceMappingURL=getAccountAllOfRelayData.js.map